import { post, postData } from './http'
import global from '@/api/global'

// export function ap (query) {
//   return http({
//     url: 'zwzhbcps/waybill/selectWaybill',
//     method: 'post',
//     data: query,
//     headers: {
//       'content-type': 'application/json;charset=UTF-8'
//     }
//   })
// }
var name = global.stockName
var shipping = global.shipping
var crm = global.crmServer
var crmServer3 = global.crmServer3
var contractName = global.contractName
// 客户列表
export const getRelationCustomer = p => post(`/${crm}api/getRelationCustomer`, p)
// 客户列表crm3
export const getRelationCustomerCrm3 = p => post(`${crmServer3}/sCustomer/list`, p)
// 船舶信息
export const cShipInfoAdd = p => post(`/${shipping}/cShipInfo/addOrUpdateShipInfo`, p)
export const cShipInfoList = p => post(`/${shipping}/cShipInfo/list`, p)
export const cShipInfoDelete = p => post(`/${shipping}/cShipInfo/delete`, p)
export const cShipInfoDetail = p => post(`/${shipping}/cShipInfo/detail`, p)
// 地址信息
export const sAddressAdd = p => post(`/${shipping}/sAddress/add`, p)
export const sAddressList = p => post(`/${shipping}/sAddress/list`, p)
export const sAddressUpdate = p => post(`/${shipping}/sAddress/update`, p)
export const sAddressDelete = p => post(`/${shipping}/sAddress/delete`, p)
// 业务单据列表
export const sBusinessList = p => post(`/${shipping}/sBusiness/list`, p)
// 业务单据增删改
export const sBusinessAdd = p => post(`/${shipping}/sBusiness/add`, p)
export const sBusinessUpdate = p => post(`/${shipping}/sBusiness/update`, p)
export const sBusinessDelete = p => post(`/${shipping}/sBusiness/delete`, p)
// 货物信息列表
export const sBusinessGoodsRelList = p => post(`/${shipping}/sBusinessGoodsRel/list`, p)
// 货物信息数据统计
export const listWeight = p => post(`/${shipping}/sBusinessGoodsRel/listWeight`, p)
// 货物信息导入
export const impSBusinessGoodsExcel = p => post(`/${shipping}/sGoods/impSBusinessGoodsExcel`, p)
// 货物信息装船
export const BGRshipMent = p => post(`/${shipping}/sBusinessGoodsRel/shipMent`, p)
// 货物信息删除
export const BGRdelete = p => post(`/${shipping}/sBusinessGoodsRel/delete`, p)
// 货物信息修改
export const sGoodsUpdate = p => post(`/${shipping}/sGoods/update`, p)
// 货物信息卸船
export const BGRshipUnload = p => post(`/${shipping}/sBusinessGoodsRel/shipUnload`, p)
// 汽运、入库单据列表
export const sWayList = p => post(`/${shipping}/sWay/list`, p)
// 汽运、入库货物列表
export const sWayGoodsRelList = p => post(`/${shipping}/sWayGoodsRel/list`, p)
// 汽运、入库单据修改
export const sWayUpdate = p => post(`/${shipping}/sWay/update`, p)
// 船期列表
export const shipDateList = p => post(`/${shipping}/shipDate/list`, p)
// 船期列表添加
export const shipDateAdd = p => post(`/${shipping}/shipDate/add`, p)
// 船期列表编辑
export const shipDateUpdate = p => post(`/${shipping}/shipDate/update`, p)
// 船期列表删除
export const shipDateDel = p => post(`/${shipping}/shipDate/delete`, p)
// 发运
export const shipSail = p => post(`/${shipping}/shipDate/shipSail`, p)
// 到港
export const businessArrival = p => post(`/${shipping}/sBusiness/businessArrival`, p)
// 坐标列表
export const shipCoordinateList = p => post(`/${shipping}/shipCoordinate/list`, p)
// 添加坐标
export const shipCoordinateListAdd = p => post(`/${shipping}/shipCoordinate/add`, p)
// 转换
export const shipUnloadSwitch = p => post(`/${shipping}/sBusinessGoodsRel/shipUnloadSwitch`, p)
// 配货列表
export const SDBlist = p => post(`/${shipping}/sDistribution/list`, p)
// 配货添加
export const SDBadd = p => post(`/${shipping}/sDistribution/add`, p)
// 配货删除
export const SDBdelete = p => post(`/${shipping}/sDistribution/delete`, p)
// 配货规则列表
export const ruleMap = p => post(`/${shipping}/sDistributionClassify/ruleMap`, p)
// 配货明细列表
export const SDBDlist = p => post(`/${shipping}/sDistributionDetail/list`, p)
// 配货明细导入
export const impSDistributionDetailExcel = p => post(`/${shipping}/sDistributionDetail/impSDistributionDetailExcel`, p)
// 配货明细预览
export const distributionPreview = p => post(`/${shipping}/sDistributionClassify/distributionPreview`, p)
// 配货明细确定
export const distributionAdd = p => post(`/${shipping}/sDistributionClassify/distributionAdd`, p)
// 配货明细备注
export const SDCupdate = p => post(`/${shipping}/sDistributionClassify/update`, p)
// 承运方——添加、修改
export const goodsCarriageFeel = p => post(`/${shipping}/sGoods/goodsCarriageFeel`, p)
// 船期管理-导入
export const impSBusinessAndGoods = p => post(`/${shipping}/sGoods/impSBusinessAndGoods`, p)

// 货位统计
export const getShipGoodsLocation = p => post(`/${shipping}/goodsLocation/getShipGoodsLocation`, p) //
export const getShipGoodsLocationList = p => post(`/${shipping}/goodsLocation/getShipGoodsLocationList`, p) // 列表
export const getShipGoodsLocationNw = p => post(`/${shipping}/goodsLocation/getShipGoodsLocationNw`, p) // 重量
export const getShipGoodsSelectList = p => post(`/${shipping}/goodsLocation/getShipGoodsSelectList`, p) // 舱位排位层位
// 货物类型
export const dropDownList = p => post(`/${name}/cProductType/dropDownList`, p)
// 船期合同列表（梁）
export const getShipContractListForBindShipData = p => post(`/${shipping}/shipContract/getShipContractListForBindShipData`, p)
// 根据合同查询地址（梁）
export const getContractAddressList = p => post(`/${shipping}/shipContract/getContractAddressList`, p)
// 根据船运id查码头（常）
export const shipBerthingAddress = p => post(`/${shipping}/shipDate/shipBerthingAddress`, p)
// 日志列表（常）
export const sShipRecordList = p => post(`/${shipping}/sShipRecord/list `, p)
// 日志添加（常）
export const addShipRecord = p => post(`/${shipping}/sShipRecord/addOrUpdateShipRecord`, p)
// 日志删除（常）
export const sShipRecordDelete = p => post(`/${shipping}/sShipRecord/delete`, p)
// 根据id获取地址信息 (梁)
export const getShipDateAddress = p => post(`/${shipping}/shipUseAddress/getShipDateAddress`, p)
// 合同-船舶名称 (梁)
export const getShipIdAndNameList = p => post(`/${shipping}/cShipInfo/getShipIdAndNameList`, p)
// 合同-新增保存 (梁)
export const shipContractAdd = p => post(`/${shipping}/shipContract/add`, p)
// 合同-修改保存 (梁)
export const shipContractUpdate = p => post(`/${shipping}/shipContract/update`, p)
// 合同-删除 (梁)
export const logicDeleteShipContract = p => post(`/${shipping}/shipContract/logicDeleteShipContract`, p)
// 合同-查询 (梁)
export const getBaseInfoList = p => post(`/${shipping}/shipContract/getBaseInfoList`, p)
// 合同-详情 (梁)
export const shipContractDetail = p => post(`/${shipping}/shipContract/detail`, p)
// 合同-照片 (梁)
export const uploadImage = p => post(`/${shipping}/shipContract/uploadImage`, p)
// 合同-照片回显 (梁)
export const getFileListByContractId = p => post(`/${shipping}/sContractFile/getFileListByContractId`, p)
// 合同-详情照片 (梁)
export const getShipFileList = p => post(`/${shipping}/cShipInfo/getShipFileList`, p)
// 合同-删除照片 (梁)
export const deleteImage = p => post(`/${shipping}/sContractFile/deleteImage`, p)
// 码单-交货地 变更 (梁)
export const changeGoodsReceivingAddress = p => post(`/${shipping}/sBusinessGoodsRel/changeGoodsReceivingAddress`, p)
// 坐标点修改(梁)
export const shipCoordinateUpdate = p => post(`/${shipping}/shipCoordinate/update`, p)
// 坐标点删除 (梁)
export const shipCoordinateDelete = p => post(`/${shipping}/shipCoordinate/delete`, p)
// 生成合同 (梁)
export const getContractPdfForBusinessNo = p => post(`/${contractName}/api/contractSignature/getContractPdfForBusinessNo`, p)
// 详情-船运单号 (梁)
export const getShipTransportNoByContractId = p => post(`/${shipping}/shipDate/getShipTransportNoByContractId`, p)
// 流向字典表(常)
export const sCrmDictionaryList = p => post(`${shipping}/sShipDictionary/list`, p)
// 报价管理列表(常)
export const sShipFlowList = p => post(`/${shipping}/sShipFlow/list`, p)
// 报价管理添加(常)
export const sShipFlowAdd = p => post(`/${shipping}/sShipFlow/add `, p)
// 报价管理删除(常)
export const sShipFlowDelete = p => post(`/${shipping}/sShipFlow/delete`, p)
// 报价管理修改报价结束(常)
export const sShipFlowUpdateFlow = p => post(`/${shipping}/sShipFlow/updateFlow`, p)
// 查看报价(常)
export const flowOffList = p => post(`/${shipping}/sShipFlow/flowOffList`, p)
// 指派报价(常)
export const appointFlow = p => post(`/${shipping}/sShipFlow/appointFlow`, p)
// 重新发布(常)
export const againPublishFlow = p => post(`/${shipping}/sShipFlow/againPublishFlow`, p)
// 船期列表(常)
export const shipperShipDateReportList = p => post(`/${shipping}/sShipDateReport/shipperShipDateReportList`, p)
// 综合查询(常)
export const allList = p => post(`/${shipping}/sBusinessGoodsRel/allList`, p)
// 码单-上报货损(常)
export const isDamage = p => post(`/${shipping}/sBusinessGoodsRel/isDamage`, p)
// 船员列表(常)
export const sShipSailorInfoList = p => post(`/${shipping}/sShipSailorInfo/list`, p)
// 船员增加(常)
export const sShipSailorInfoAdd = p => post(`/${shipping}/sShipSailorInfo/add`, p)
// 船员删除(常)
export const sShipSailorInfoDelete = p => post(`/${shipping}/sShipSailorInfo/delete`, p)
// 船员列表(常)
export const sShipSailorInfoUpdate = p => post(`/${shipping}/sShipSailorInfo/update`, p)
// 流向添加(常)
export const sShipDictionaryADD = p => post(`/${shipping}/sShipDictionary/add`, p)
// 流向更新(常)
export const sShipDictionaryUpdate = p => post(`/${shipping}/sShipDictionary/update`, p)
// 流向删除(常)
export const sShipDictionaryDelete = p => post(`/${shipping}/sShipDictionary/delete`, p)
// 流向列表(常)
export const sShipDictionaryList = p => post(`/${shipping}/sShipDictionary/list`, p)
// 结算列表(常)
export const sShipSettlementList = p => post(`/${shipping}/sShipSettlement/list `, p)
// 结算新建修改(常)
export const addOrUpdateSettlement = p => post(`/${shipping}/sShipSettlement/addOrUpdateSettlement`, p)
// 结算删除(常)
export const sShipSettlementDelete = p => post(`/${shipping}/sShipSettlement/delete`, p)
// 结算-归属标记(常)
export const belongSign = p => post(`/${shipping}/sShipSettlement/belongSign`, p)
// 获取船运单据详情(常)
export const shipDateDetail = p => post(`/${shipping}/shipDate/detail`, p)
// 查看图片(常)type  类型 1，滞期涵 2，付款凭证 3，发票照片'
export const settlementFile = p => post(`/${shipping}/sShipSettlement/settlementFile`, p)
// 结算-付款列表(常)
export const sShipPayList = p => post(`/${shipping}/sShipPay/list`, p)
// 结算-付款新增修改(常)
export const addOrUpdatePay = p => post(`/${shipping}/sShipPay/addOrUpdatePay`, p)
// 结算-付款删除(常)
export const sShipPayDelete = p => post(`/${shipping}/sShipPay/delete`, p)
// 结算-发票列表(常)
export const sShipInvoiceList = p => post(`/${shipping}/sShipInvoice/list`, p)
// 结算-发票新增修改(常)
export const addOrUpdateInvoice = p => post(`/${shipping}/sShipInvoice/addOrUpdateInvoice`, p)
// 结算-发票删除(常)
export const sShipInvoiceDelete = p => post(`/${shipping}/sShipInvoice/delete`, p)
// 同比统计(常)
export const monthCompare = p => post(`/${shipping}/sShipSettlement/monthCompare`, p)
// 喷码任务列表(尚)
export const getShipInkjetTaskList = p => post(`/${shipping}/shipInkjetTask/getShipInkjetTaskList`, p)
// 喷码任务详情(尚)
export const shipInkjetTaskDetail = p => post(`/${shipping}/shipInkjetTask/detail`, p)
// 喷码任务新增(尚)
export const addShipInkjetTask = p => post(`/${shipping}/shipInkjetTask/addShipInkjetTask`, p)
// 喷码任务修改(尚)
export const upShipInkjetTask = p => post(`/${shipping}/shipInkjetTask/upShipInkjetTask`, p)
// 喷码任务删除(尚)
export const delShipInkjetTask = p => post(`/${shipping}/shipInkjetTask/delShipInkjetTask`, p)
// 喷码任务货物明细(尚)
export const getShipInkjetDetailList = p => post(`/${shipping}/shipInkjetTask/getShipInkjetDetailList`, p)
// 喷码任务货物删除(尚)
export const delShipInkjetDetail = p => post(`/${shipping}/shipInkjetTask/delShipInkjetDetail`, p)
// 喷码任务货物导入(尚)
export const addShipInkjetDetail = p => post(`/${shipping}/shipInkjetTask/addShipInkjetDetail`, p)
